import { render, staticRenderFns } from "./AgentContactModal.vue?vue&type=template&id=487b503b&scoped=true&"
import script from "./AgentContactModal.vue?vue&type=script&lang=js&"
export * from "./AgentContactModal.vue?vue&type=script&lang=js&"
import style0 from "./AgentContactModal.vue?vue&type=style&index=0&id=487b503b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b503b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VTextField})
